import { useContext, useEffect, useState } from 'react';
import { Button } from 'reactstrap';
import { renderIcon } from '~/shared/components/icons';
import SidebarLink from './SidebarLink';
import SidebarCategory from './SidebarCategory';
import { PhotoCard } from '~/shared/components/cards/PhotoCard';
import { AuthContext } from '~/context/auth';
import { AdminContext } from '~/context/admin';
import { CampaignContext } from '~/context/campaign';
import { NavLink, useHistory } from 'react-router-dom';
import { MyIdContext } from '~/context/my-id';
import { GrantsContext } from '~/context/grants';

const SidebarContent = (props) => {
    const [{ user, person }, userDispatch] = useContext(AuthContext);
    const [{ campaign }, campaignDispatch] = useContext(CampaignContext);
    const [{ campaignId, isAdmin }, adminDispatch] = useContext(AdminContext);
    const my_id_panel = useContext(MyIdContext)[0].my_id_panel;
    const [grants] = useContext(GrantsContext);
    const history = useHistory();
    const [isLimited, setIsLimited] = useState(false);

    console.log('My access: ', person?.groups[0]?.name);

    // Check if fund requests should be shown based on:
    // 1. Campaign status is Funded or Disbursable
    const campaignStatus = campaign?.campaignDetail?.campaign_status;
    const isFundedOrDisbursable = campaignStatus === 'Disbursable';
    const showFundRequests = isAdmin || isFundedOrDisbursable;

    useEffect(() => {
        const access = person?.groups[0]?.name;
        if (access === 'limited team member') {
            setIsLimited(true);
        }
    }, [person]);

    const hideSidebar = () => {
        const { onClick } = props;
        onClick();
    };

    const unpublished =
        campaign && campaign?.campaignDetail?.campaign_status === 'Unpublished';
    const inactive =
        campaign && campaign?.campaignDetail?.campaign_status === 'Inactive';

    const logout = async () => {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        userDispatch({
            type: 'set_user',
            user: null,
        });
        campaignDispatch({
            type: 'set_campaign',
            payload: null,
        });
        campaignDispatch({
            type: 'set_campaign_show_message',
            payload: true,
        });
        adminDispatch({
            type: 'reset_state',
        });
        history.push('/login');
    };

    const supportersLink = () => {
        if (isLimited) {
            return <></>;
        } else if (!grants?.grants?.length) {
            return (
                <SidebarLink
                    title='Supporters'
                    route='/campaign/supporters/donations'
                    onClick={hideSidebar}
                />
            );
        } else {
            return (
                <SidebarCategory
                    title='Supporters'
                    style={{ marginBottom: '8px' }}
                >
                    <SidebarLink
                        title='Donations'
                        route='/campaign/supporters/donations'
                        onClick={hideSidebar}
                    />
                    <SidebarLink
                        title='Grants'
                        route='/campaign/supporters/grants'
                        onClick={hideSidebar}
                    />
                </SidebarCategory>
            );
        }
    };

    return (
        <div className='sidebar__content'>
            <a className='sidebar__logo' href={import.meta.env.VITE_WP_URL} />
            <NavLink to='/campaign/edit'>
                <PhotoCard hideSidebar={hideSidebar} />
            </NavLink>

            {campaign?.campaignCoordinator && (
                <div className='coordinator-info'>
                    <div>
                        <div className='coordinator-title'>
                            Client Services Coordinator
                        </div>
                        <div className='coordinator-name'>
                            {campaign?.campaignCoordinator?.name}
                        </div>
                    </div>
                    <div className='d-flex'>
                        <Button
                            className='me-2'
                            color='link'
                            href={`mailto:${campaign?.campaignCoordinator?.email}`}
                        >
                            {renderIcon('email')}
                        </Button>
                        <Button
                            color='link'
                            href={`tel:${campaign?.campaignCoordinator?.phone}`}
                        >
                            {renderIcon('phone_access')}
                        </Button>
                    </div>
                </div>
            )}

            <div className='sidebar__block'>
                {campaign?.campaignDetail?.wordpress_permalink && (
                    <a
                        href={campaign.campaignDetail.wordpress_permalink}
                        target='_blank'
                        rel='noopener noreferrer'
                        className='text-decoration-none'
                    >
                        <span className='sidebar__link mb-2'>
                            <span className='sidebar__link-icon'>
                                {renderIcon('campaign')}
                            </span>
                            <p className='sidebar__link-title'>View Campaign</p>
                        </span>
                    </a>
                )}
                <SidebarLink
                    icon='dashboard'
                    title='Dashboard'
                    route='/dashboard'
                    onClick={hideSidebar}
                />
                {person?.groups[0]?.name !== 'limited team member' && (
                    <SidebarLink
                        icon='client'
                        title='Client'
                        route='/patient/edit'
                        onClick={hideSidebar}
                    />
                )}
                <SidebarCategory title='Campaign' icon='campaign'>
                    <SidebarLink
                        title='Edit'
                        route='/campaign/edit'
                        onClick={hideSidebar}
                    />
                    <SidebarLink
                        title='Updates'
                        route='/campaign/updates'
                        onClick={hideSidebar}
                    />

                    {supportersLink()}

                    <SidebarLink
                        title='Guestbook'
                        route='/campaign/guestbook'
                        onClick={hideSidebar}
                    />
                    {/* <SidebarLink
            title='Files'
            route='/campaign/files'
            onClick={hideSidebar}
          /> */}
                </SidebarCategory>
                {showFundRequests && (
                    <SidebarCategory title='Requests' icon='expenses'>
                        <SidebarLink
                            title='Fund Requests'
                            route='/requests'
                            onClick={hideSidebar}
                        />
                        <SidebarLink
                            title='Payees'
                            route='/payees'
                            onClick={hideSidebar}
                        />
                    </SidebarCategory>
                )}
                {/* <SidebarCategory title='Expenses' icon='expenses'>
          <SidebarLink
            title='Expenses'
            route='/expenses'
            onClick={hideSidebar}
          />
          <SidebarLink
            title='Submit Request'
            route='/expenses/request/submit'
            onClick={hideSidebar}
          />
          <SidebarLink
            title='Direct Deposit'
            route='/expenses/direct/deposit'
            onClick={hideSidebar}
          />
        </SidebarCategory> */}
                {!unpublished && !inactive && !isLimited && (
                    <SidebarLink
                        title='Disbursements'
                        route='/disbursements'
                        onClick={hideSidebar}
                        icon='expenses'
                    />
                )}

                <SidebarLink
                    icon='team'
                    title='Team'
                    route='/team'
                    onClick={hideSidebar}
                />
                {!unpublished && !inactive && (
                    <SidebarLink
                        icon='fundraisers'
                        title='Fundraisers'
                        route='/fundraisers'
                        onClick={hideSidebar}
                    />
                )}
                <SidebarLink
                    icon='helpful-tools'
                    title='Helpful Tools'
                    route='/helpful-tools'
                    onClick={hideSidebar}
                />
                <SidebarLink
                    icon='profile'
                    title='My Profile'
                    route='/profile'
                    onClick={hideSidebar}
                />
                {my_id_panel && (
                    <SidebarLink
                        icon='my_id'
                        title='MyID'
                        route='/my-id'
                        onClick={hideSidebar}
                    />
                )}
                <SidebarLink icon='logout' title='Sign Out' onClick={logout} />
                {/* <SidebarLink icon="user" title="People" route="/people" onClick={hideSidebar} /> */}
                {/* <SidebarLink icon="" title="TEST" route="/customers" onClick={hideSidebar} /> */}
                {/* <SidebarLink icon="hospital" title="US Medical Centers" route="/medcenters_us" onClick={hideSidebar} /> */}
            </div>
        </div>
    );
};

export default SidebarContent;
